import {CmWidgetSettings} from '../cm-widget.component';
import {AlertRequest} from '../../../domain/alerts/alert-request.model';
import {DateRangeHolder} from '../../../../../shared/domain/date-range-holder.model';
export class WidgetAlertsSettings extends CmWidgetSettings {
  request: AlertRequest;
  dateRange: DateRangeHolder;

  constructor() {
    super();
    this.request = new AlertRequest();
  }
}
